// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  accent-color: black;
}

/* Note: Size in Safari will be improved but smaller than results in other browsers */
[type="radio"] {
  font-size: inherit;
  width: 0.75em;
  height: 0.75em;
}
.login-main {
  display: flex;
  width: 100%;
  overflow: hidden;
}
.login-main .content-wrapper {
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  height: 100vh;
}
.login-main .banner-part {
  display: flex;
  flex: 1 1 auto;
  height: 100%;
  background: #fdf5f2;
  align-items: center;
  justify-content: center;
}
.login-main .banner-part .banner-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1 1;
}
.login-main .banner-part .banner-content img {
  width: 50%;
  opacity: 0.9;
}
.login-main .banner-part .banner-content .text-part {
  display: flex;
  max-width: 50%;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 15px;
}
.login-main .banner-part .banner-content .text-part h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 120%;
  margin: 0;
}
.login-main .banner-part .banner-content .text-part p {
  margin: 0;
  font-size: 14px;
  color: #adadad;
}
.login-main .form-part {
  display: flex;
  padding: 0px 0px;
  position: relative;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1 auto;
  height: 100%;
  background-color: #fdf5f2;
}
.login-main .form-part .close-btn {
  all: unset;
  position: absolute;
  right: 25px;
  top: 25px;
  cursor: pointer;
}
.login-main .form-part .content {
  display: flex;
  flex-direction: column;
  width: 80%;
  gap: 20px;
  padding: 30px 50px;
  background-color: white;
  align-items: center;
  box-shadow: rgba(0, 0, 2, 0.2) 0px 1px 12px 0px; /* Adjust the shadow as needed */
border-radius: 14px;

}
.login-main .form-part .content .header-part {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 50%;
}
.login-main .form-part .content .header-part h3 {
  font-size: 30px;
  font-weight: 500;
  line-height: 130%;
  margin: 0;
  color: #1D2432;
}
.login-main .form-part .content .header-part p {
  font-size: 14px;
  font-weight: 400;
  color: #1D2432;
  margin: 0;
}
.login-main .form-part .content .middle-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 80%;
  gap: 10px;
}
.login-main .form-part .content .middle-form .input-part {
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid #EAEAEA;
  border-radius: 12px;
  padding: 10px;
  gap: 10px;
}
.login-main .form-part .content .middle-form .input-part .menu-flags{
  padding-bottom: 0;
}
.login-main .form-part .content .middle-form .input-part .menu-flags .menu-flags-button{
  border: none;
  font-weight: 400;
  color: #adadad;
  padding: 0;
}
.login-main .form-part .content .middle-form .input-part .menu-flags .menu-flags-button:after{
  margin: 0;
  border-top: 5px solid #adadad;
}
.login-main .form-part .content .middle-form .input-part .menu-flags .menu-flags-button[aria-expanded="true"]:after {
  border-bottom: 5px solid #adadad;
  border-top: 0;
  margin-bottom: 2px;
}
.login-main .form-part .content .middle-form .input-part .menu-flags .selectOptions{
  width: 100px;
}
.login-main .form-part .content .middle-form .input-part p {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #adadad;
  margin-right: 15px;
}
.login-main .form-part .content .middle-form .input-part input {
  all: unset;
  font-size: 16px;
  font-weight: 400;
}
.login-main .form-part .content .middle-form .info-text {
  width: 100%;
  font-size: 10px;
  font-weight: 400;
  color: #adadad;
  text-decoration: none;
}
.login-main .form-part .content .middle-form .info-text a {
  text-decoration: none;
  color: #ff6f48;
  font-weight: 500;
}
.login-main .form-part .content .action-part {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 80%;
  align-items: flex-start;
  justify-content: flex-start;
}
.login-main .form-part .content .action-part .btn-orange {
  display: inline-flex;
  padding: 10px;
  border-radius: 30px;
  background: #ff6f48;
  width: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 25px;
  color: white;
  border: 1px solid #ff6f48;
  font-weight: 600;
}
.login-main .form-part .content .action-part .btn-orange:hover {
  color: #ff6f48;
  background-color: #fff;
}
.login-main .form-part .content .action-part .btn-orange.outline {
  background: #fff;
  border: 1px solid #ff6f48;
  color: #ff6f48;
  font-weight: 600;
}
.login-main .form-part .content .action-part .btn-orange.outline:hover {
  color: white;
  background: #ff6f48;
}
.login-main .form-part .content .action-part .divider {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 32px;
}
.login-main .form-part .content .action-part .divider span {
  width: 100%;
  background: #EAEAEA;
  height: 1px;
}
.login-main .form-part .content .action-part .divider .text {
  margin: 0;
  padding: 5px 8px;
  background-color: white;
  font-size: 12px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  color: #ADADAD;
}
.content-modal {
  display: flex;
  flex-direction: column;
  background: white;
  width: 100%;
  position: relative;
}
.content-modal .top-btn-part {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.content-modal .top-btn-part .close-btn{
  position: absolute;
  top: -40px;
  right: -30px;
}
.content-modal .modal-inside-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  width: 100%;
  gap: 10px;
}
.content-modal .modal-inside-content .edit-badge {
  background-color: #ff6f4833 !important;
  color: #ff6f48 !important;
  padding: 6px 10px;
    margin-left: 10px;
    font-size: 10px;
    font-weight: 500;
}
.content-modal .modal-inside-content .heading {
  margin: 0;
  font-size: 22px;
  font-weight: 500;
  color: #1D2432;
}
.content-modal .modal-inside-content .desc-text {
  font-size: 14px;
  font-weight: 400;
  color: #1D2432;
  margin: 0;
}
.content-modal .modal-inside-content .mobileno {
  font-size: 16px;
  font-weight: 600;
  margin: 10px 0;
  color: #1D2432;
  display: flex;
  align-items: center;
}
.content-modal .modal-inside-content .otp-input-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.content-modal .modal-inside-content .otp-input-group input {
  width: 52px;
  height: 52px;
  font-size: 18px;
  font-weight: 400;
  color: #1D2432;
  text-align: center;
  border: 1px solid #EAEAEA;
  border-radius: 8px;
}

.content-modal .modal-inside-content .otp-input-group input:focus {
  outline: none;
  border-color: #EAEAEA;
}
.content-modal .modal-inside-content .btn-continue {
    all: unset;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 90px;
    color: white;
    font-size: 16px;
    font-weight: 600;
    background-color: #ff6f48;
    border-radius: 30px;
}

.content-modal .modal-inside-content .notreceive-text {
    color: #adadad;
    font-size: 12px;
    font-weight: 400;
    margin: 0;
}
.content-modal .modal-inside-content .resend-btn {
    all: unset;
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    color: #ff6f48;
    margin: -10px 0;
}
.content-modal .modal-inside-content .timer {
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 25px;
    color: #1D2432;
}

.react-tel-input .flag-dropdown {
  position: absolute;
  top: 0;
  bottom: 0;
  padding: 0;
  background-color:transparent !important; 
  border: none !important;
 border-radius:none !important;
}

.react-tel-input .form-control {
  position: relative;
  font-size: 14px;
  letter-spacing: .01rem;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-left: 48px !important;
  margin-left: 0;
  background: #FFFFFF;
  border: 1px solid #CACACA;
  border-radius: 5px;
  line-height: 25px;
  /* height: 52px !important; */
  width: 300px;
  outline: none;
}
.field-error {
  border: 2px solid red !important;
  outline: none !important;
  box-shadow:  0 0 0.25rem rgba(13,110,253,.25)
}

.field-error:focus  , .field-error > .form-control:focus{
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.667) !important;
  /* Add a box shadow for more emphasis */

}
.resend-btn:disabled {
  /* Add your styles for the disabled button here */
  cursor: not-allowed; /* Shows a 'not allowed' cursor */
  opacity: 0.5; /* Optionally make the button look faded */
  /* Remove other styles that may indicate interactivity */
}
@media (max-width: 768px) {
  /* Adjusting the layout to stack form-part above banner-part */
  .login-main .content-wrapper {
    display: flex;
    flex-direction: column;
    height: auto; /* Let height adjust automatically for mobile */
  }
  
  /* Ensure banner-part shows below form-part */
  .login-main .form-part {
    order: 1;
    width: 100%;
    justify-content: center;
  }

  .login-main .banner-part {
    order: 2;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 20px; /* Optional padding for better spacing on mobile */
  }
}

/* Mobile logo adjustment */
.mobile-logo {
  display: none; /* Hide logo by default */
}
.main-text {
  text-align: start;
}

@media (max-width: 768px) {
  .mobile-logo {
    display: block; /* Show logo on mobile screens */
    background-color: #fdf5f2;
  }
  .laptop-logo {
    display: none; /* Hide logo by default */
  }
  .login-main .form-part {
    justify-content: center !important;
  }
  .main-text {
    text-align: center;
  }
}


@media screen and (max-width: 768px) {
  .login-main .form-part .content {
    width: 90%; /* 90% width for mobile screens */
    padding: 30px 10px;
  }
  .login-main .form-part{
    padding: 0px !important ;
  }
}

/* Base styles */
.container.main-text {
  padding-left: 5rem;
  padding-right: 5rem;
  width: 100%; /* Ensure container takes full width */
  box-sizing: border-box; /* Includes padding in the width */
  overflow: hidden; /* Prevents content overflow */
}

/* Mobile screen styles */
@media screen and (max-width: 768px) {
  

  .container.main-text h3 {
    font-size: 18px; /* Adjust font size for mobile */
    line-height: 1.4; /* Add proper spacing between lines */
    word-wrap: break-word; /* Ensure long words don't overflow */
  }
  .banner-part .container {
    width: 60%;
    padding-left: 1rem !important; /* Reduce padding for smaller screens */
    padding-right: 1rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/login.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA,qFAAqF;AACrF;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAO;AACT;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C,EAAE,gCAAgC;AACnF,mBAAmB;;AAEnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;AACA;EACE,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,iBAAiB;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;IACI,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,uCAAuC;EACvC,uBAAuB;CACxB,6BAA6B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,wBAAwB;EACxB;AACF;;AAEA;EACE,qDAAqD;EACrD,uCAAuC;;AAEzC;AACA;EACE,iDAAiD;EACjD,mBAAmB,EAAE,iCAAiC;EACtD,YAAY,EAAE,0CAA0C;EACxD,wDAAwD;AAC1D;AACA;EACE,8DAA8D;EAC9D;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAE,+CAA+C;EAC/D;;EAEA,6CAA6C;EAC7C;IACE,QAAQ;IACR,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,aAAa,EAAE,kDAAkD;EACnE;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa,EAAE,yBAAyB;AAC1C;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc,EAAE,gCAAgC;IAChD,yBAAyB;EAC3B;EACA;IACE,aAAa,EAAE,yBAAyB;EAC1C;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kBAAkB;EACpB;AACF;;;AAGA;EACE;IACE,UAAU,EAAE,iCAAiC;IAC7C,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW,EAAE,sCAAsC;EACnD,sBAAsB,EAAE,kCAAkC;EAC1D,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA,yBAAyB;AACzB;;;EAGE;IACE,eAAe,EAAE,gCAAgC;IACjD,gBAAgB,EAAE,qCAAqC;IACvD,qBAAqB,EAAE,qCAAqC;EAC9D;EACA;IACE,UAAU;IACV,6BAA6B,EAAE,uCAAuC;IACtE,8BAA8B;EAChC;AACF","sourcesContent":[":root {\r\n  accent-color: black;\r\n}\r\n\r\n/* Note: Size in Safari will be improved but smaller than results in other browsers */\r\n[type=\"radio\"] {\r\n  font-size: inherit;\r\n  width: 0.75em;\r\n  height: 0.75em;\r\n}\r\n.login-main {\r\n  display: flex;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n.login-main .content-wrapper {\r\n  display: grid;\r\n  grid-template-columns: 50% 50%;\r\n  width: 100%;\r\n  height: 100vh;\r\n}\r\n.login-main .banner-part {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  height: 100%;\r\n  background: #fdf5f2;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.login-main .banner-part .banner-content {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  flex: 1;\r\n}\r\n.login-main .banner-part .banner-content img {\r\n  width: 50%;\r\n  opacity: 0.9;\r\n}\r\n.login-main .banner-part .banner-content .text-part {\r\n  display: flex;\r\n  max-width: 50%;\r\n  margin: 0 auto;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  gap: 15px;\r\n}\r\n.login-main .banner-part .banner-content .text-part h4 {\r\n  font-size: 22px;\r\n  font-weight: 500;\r\n  line-height: 120%;\r\n  margin: 0;\r\n}\r\n.login-main .banner-part .banner-content .text-part p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: #adadad;\r\n}\r\n.login-main .form-part {\r\n  display: flex;\r\n  padding: 0px 0px;\r\n  position: relative;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  flex: 1 1 auto;\r\n  height: 100%;\r\n  background-color: #fdf5f2;\r\n}\r\n.login-main .form-part .close-btn {\r\n  all: unset;\r\n  position: absolute;\r\n  right: 25px;\r\n  top: 25px;\r\n  cursor: pointer;\r\n}\r\n.login-main .form-part .content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 80%;\r\n  gap: 20px;\r\n  padding: 30px 50px;\r\n  background-color: white;\r\n  align-items: center;\r\n  box-shadow: rgba(0, 0, 2, 0.2) 0px 1px 12px 0px; /* Adjust the shadow as needed */\r\nborder-radius: 14px;\r\n\r\n}\r\n.login-main .form-part .content .header-part {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  width: 50%;\r\n}\r\n.login-main .form-part .content .header-part h3 {\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n  line-height: 130%;\r\n  margin: 0;\r\n  color: #1D2432;\r\n}\r\n.login-main .form-part .content .header-part p {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #1D2432;\r\n  margin: 0;\r\n}\r\n.login-main .form-part .content .middle-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  width: 80%;\r\n  gap: 10px;\r\n}\r\n.login-main .form-part .content .middle-form .input-part {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  border: 1px solid #EAEAEA;\r\n  border-radius: 12px;\r\n  padding: 10px;\r\n  gap: 10px;\r\n}\r\n.login-main .form-part .content .middle-form .input-part .menu-flags{\r\n  padding-bottom: 0;\r\n}\r\n.login-main .form-part .content .middle-form .input-part .menu-flags .menu-flags-button{\r\n  border: none;\r\n  font-weight: 400;\r\n  color: #adadad;\r\n  padding: 0;\r\n}\r\n.login-main .form-part .content .middle-form .input-part .menu-flags .menu-flags-button:after{\r\n  margin: 0;\r\n  border-top: 5px solid #adadad;\r\n}\r\n.login-main .form-part .content .middle-form .input-part .menu-flags .menu-flags-button[aria-expanded=\"true\"]:after {\r\n  border-bottom: 5px solid #adadad;\r\n  border-top: 0;\r\n  margin-bottom: 2px;\r\n}\r\n.login-main .form-part .content .middle-form .input-part .menu-flags .selectOptions{\r\n  width: 100px;\r\n}\r\n.login-main .form-part .content .middle-form .input-part p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #adadad;\r\n  margin-right: 15px;\r\n}\r\n.login-main .form-part .content .middle-form .input-part input {\r\n  all: unset;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n}\r\n.login-main .form-part .content .middle-form .info-text {\r\n  width: 100%;\r\n  font-size: 10px;\r\n  font-weight: 400;\r\n  color: #adadad;\r\n  text-decoration: none;\r\n}\r\n.login-main .form-part .content .middle-form .info-text a {\r\n  text-decoration: none;\r\n  color: #ff6f48;\r\n  font-weight: 500;\r\n}\r\n.login-main .form-part .content .action-part {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n  width: 80%;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n}\r\n.login-main .form-part .content .action-part .btn-orange {\r\n  display: inline-flex;\r\n  padding: 10px;\r\n  border-radius: 30px;\r\n  background: #ff6f48;\r\n  width: 100%;\r\n  text-align: center;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 16px;\r\n  line-height: 25px;\r\n  color: white;\r\n  border: 1px solid #ff6f48;\r\n  font-weight: 600;\r\n}\r\n.login-main .form-part .content .action-part .btn-orange:hover {\r\n  color: #ff6f48;\r\n  background-color: #fff;\r\n}\r\n.login-main .form-part .content .action-part .btn-orange.outline {\r\n  background: #fff;\r\n  border: 1px solid #ff6f48;\r\n  color: #ff6f48;\r\n  font-weight: 600;\r\n}\r\n.login-main .form-part .content .action-part .btn-orange.outline:hover {\r\n  color: white;\r\n  background: #ff6f48;\r\n}\r\n.login-main .form-part .content .action-part .divider {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n  width: 100%;\r\n  height: 32px;\r\n}\r\n.login-main .form-part .content .action-part .divider span {\r\n  width: 100%;\r\n  background: #EAEAEA;\r\n  height: 1px;\r\n}\r\n.login-main .form-part .content .action-part .divider .text {\r\n  margin: 0;\r\n  padding: 5px 8px;\r\n  background-color: white;\r\n  font-size: 12px;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  color: #ADADAD;\r\n}\r\n.content-modal {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: white;\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n.content-modal .top-btn-part {\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: flex-end;\r\n}\r\n.content-modal .top-btn-part .close-btn{\r\n  position: absolute;\r\n  top: -40px;\r\n  right: -30px;\r\n}\r\n.content-modal .modal-inside-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  text-align: center;\r\n  width: 100%;\r\n  gap: 10px;\r\n}\r\n.content-modal .modal-inside-content .edit-badge {\r\n  background-color: #ff6f4833 !important;\r\n  color: #ff6f48 !important;\r\n  padding: 6px 10px;\r\n    margin-left: 10px;\r\n    font-size: 10px;\r\n    font-weight: 500;\r\n}\r\n.content-modal .modal-inside-content .heading {\r\n  margin: 0;\r\n  font-size: 22px;\r\n  font-weight: 500;\r\n  color: #1D2432;\r\n}\r\n.content-modal .modal-inside-content .desc-text {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #1D2432;\r\n  margin: 0;\r\n}\r\n.content-modal .modal-inside-content .mobileno {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  margin: 10px 0;\r\n  color: #1D2432;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.content-modal .modal-inside-content .otp-input-group {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n.content-modal .modal-inside-content .otp-input-group input {\r\n  width: 52px;\r\n  height: 52px;\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  color: #1D2432;\r\n  text-align: center;\r\n  border: 1px solid #EAEAEA;\r\n  border-radius: 8px;\r\n}\r\n\r\n.content-modal .modal-inside-content .otp-input-group input:focus {\r\n  outline: none;\r\n  border-color: #EAEAEA;\r\n}\r\n.content-modal .modal-inside-content .btn-continue {\r\n    all: unset;\r\n    cursor: pointer;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 10px 90px;\r\n    color: white;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    background-color: #ff6f48;\r\n    border-radius: 30px;\r\n}\r\n\r\n.content-modal .modal-inside-content .notreceive-text {\r\n    color: #adadad;\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    margin: 0;\r\n}\r\n.content-modal .modal-inside-content .resend-btn {\r\n    all: unset;\r\n    cursor: pointer;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    color: #ff6f48;\r\n    margin: -10px 0;\r\n}\r\n.content-modal .modal-inside-content .timer {\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    margin-bottom: 25px;\r\n    color: #1D2432;\r\n}\r\n\r\n.react-tel-input .flag-dropdown {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  padding: 0;\r\n  background-color:transparent !important; \r\n  border: none !important;\r\n border-radius:none !important;\r\n}\r\n\r\n.react-tel-input .form-control {\r\n  position: relative;\r\n  font-size: 14px;\r\n  letter-spacing: .01rem;\r\n  margin-top: 0 !important;\r\n  margin-bottom: 0 !important;\r\n  padding-left: 48px !important;\r\n  margin-left: 0;\r\n  background: #FFFFFF;\r\n  border: 1px solid #CACACA;\r\n  border-radius: 5px;\r\n  line-height: 25px;\r\n  /* height: 52px !important; */\r\n  width: 300px;\r\n  outline: none;\r\n}\r\n.field-error {\r\n  border: 2px solid red !important;\r\n  outline: none !important;\r\n  box-shadow:  0 0 0.25rem rgba(13,110,253,.25)\r\n}\r\n\r\n.field-error:focus  , .field-error > .form-control:focus{\r\n  box-shadow: 0 0 5px rgba(255, 0, 0, 0.667) !important;\r\n  /* Add a box shadow for more emphasis */\r\n\r\n}\r\n.resend-btn:disabled {\r\n  /* Add your styles for the disabled button here */\r\n  cursor: not-allowed; /* Shows a 'not allowed' cursor */\r\n  opacity: 0.5; /* Optionally make the button look faded */\r\n  /* Remove other styles that may indicate interactivity */\r\n}\r\n@media (max-width: 768px) {\r\n  /* Adjusting the layout to stack form-part above banner-part */\r\n  .login-main .content-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: auto; /* Let height adjust automatically for mobile */\r\n  }\r\n  \r\n  /* Ensure banner-part shows below form-part */\r\n  .login-main .form-part {\r\n    order: 1;\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .login-main .banner-part {\r\n    order: 2;\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 100%;\r\n    padding: 20px; /* Optional padding for better spacing on mobile */\r\n  }\r\n}\r\n\r\n/* Mobile logo adjustment */\r\n.mobile-logo {\r\n  display: none; /* Hide logo by default */\r\n}\r\n.main-text {\r\n  text-align: start;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .mobile-logo {\r\n    display: block; /* Show logo on mobile screens */\r\n    background-color: #fdf5f2;\r\n  }\r\n  .laptop-logo {\r\n    display: none; /* Hide logo by default */\r\n  }\r\n  .login-main .form-part {\r\n    justify-content: center !important;\r\n  }\r\n  .main-text {\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n\r\n@media screen and (max-width: 768px) {\r\n  .login-main .form-part .content {\r\n    width: 90%; /* 90% width for mobile screens */\r\n    padding: 30px 10px;\r\n  }\r\n  .login-main .form-part{\r\n    padding: 0px !important ;\r\n  }\r\n}\r\n\r\n/* Base styles */\r\n.container.main-text {\r\n  padding-left: 5rem;\r\n  padding-right: 5rem;\r\n  width: 100%; /* Ensure container takes full width */\r\n  box-sizing: border-box; /* Includes padding in the width */\r\n  overflow: hidden; /* Prevents content overflow */\r\n}\r\n\r\n/* Mobile screen styles */\r\n@media screen and (max-width: 768px) {\r\n  \r\n\r\n  .container.main-text h3 {\r\n    font-size: 18px; /* Adjust font size for mobile */\r\n    line-height: 1.4; /* Add proper spacing between lines */\r\n    word-wrap: break-word; /* Ensure long words don't overflow */\r\n  }\r\n  .banner-part .container {\r\n    width: 60%;\r\n    padding-left: 1rem !important; /* Reduce padding for smaller screens */\r\n    padding-right: 1rem !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
